var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"optional  custom-btn-color"},[_vm._v(_vm._s(_vm.$t("common.optionalLabel")))])}
var staticRenderFns = []

export { render, staticRenderFns }